import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgTextListNumbered24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Numbered List",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#text_-_list_numbered24_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.75 4.5a.75.75 0 0 1 .75-.75h11.75a.75.75 0 0 1 0 1.5H9.5a.75.75 0 0 1-.75-.75M8.75 19.5a.75.75 0 0 1 .75-.75h11.75a.75.75 0 0 1 0 1.5H9.5a.75.75 0 0 1-.75-.75M8.75 12a.75.75 0 0 1 .75-.75h11.75a.75.75 0 0 1 0 1.5H9.5a.75.75 0 0 1-.75-.75",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.625 3.25h.625v3.125c0 .35.275.625.625.625s.625-.275.625-.625v-3.75A.62.62 0 0 0 4.875 2h-1.25A.62.62 0 0 0 3 2.625c0 .35.275.625.625.625M5.625 9.5h-2.5a.62.62 0 0 0-.625.625c0 .35.275.625.625.625H4.75l-2.1 2.45a.6.6 0 0 0-.15.4v.275c0 .35.275.625.625.625h2.5c.35 0 .625-.275.625-.625a.62.62 0 0 0-.625-.625H4l2.1-2.45c.1-.113.15-.263.15-.4v-.275a.62.62 0 0 0-.625-.625M5.625 17.25h-2.5c-.35 0-.625.261-.625.594s.275.593.625.593H5v.594h-.625c-.35 0-.625.262-.625.594s.275.594.625.594H5v.593H3.125c-.35 0-.625.262-.625.594 0 .333.275.594.625.594h2.5c.35 0 .625-.261.625-.594v-3.562c0-.333-.275-.594-.625-.594"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "text_-_list_numbered24_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));

export { SvgTextListNumbered24 as default };
//# sourceMappingURL=TextListNumbered24.js.map
